// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

// Write your code!
import 'scroll-scene-element';

const isMobile = window.innerWidth < 768 ? true : false;

// topper vid

// fading fx

function fadeOut(el) {
  el.classList.remove('opacity-active');
  el.classList.add('opacity-inactive');
}

function fadeIn(el) {
  el.classList.remove('opacity-inactive');
  el.classList.add('opacity-active');
}

const topper = document.querySelector('.big-intro');
const article = document.getElementById('content-container');

topper.addEventListener('scroll-scene-enter', (event) => {
  event.stopPropagation();
  let card = event.detail.element.querySelector('.card');

  fadeIn(card);
});

topper.addEventListener('scroll-scene-exit', (event) => {
  event.stopPropagation();
  let detail = event.detail;
  let card = detail.element.querySelector('.card');

  if (!detail.element.classList.contains('stick')) {
    fadeOut(card);
  }
});

article.addEventListener('scroll-scene-enter', (event) => {
  event.stopPropagation();

  let item = event.detail.element;

  if (item.classList.contains('video-offset')) {
    item.offset = isMobile ? 0.5 : 0.4;
  } else {
    item.offset = isMobile ? 0.7 : 0.3;
  }

  item.classList.remove('opacity-inactive');
  item.classList.add('opacity-active');
});

article.addEventListener('scroll-scene-exit', (event) => {
  event.stopPropagation();
  let detail = event.detail;
  let item = detail.element;
  let ybound = detail.bounds.y;

  let itemPassed = Math.sign(ybound) == -1;

  if (item.classList.contains('tribute-video')) {
    item.offset = isMobile ? 0.8 : 0.5;
  }

  if (item.classList.contains('video-offset')) {
    fadeOut(item);
  }

  if (!item.classList.contains('stick') && itemPassed) {
    fadeOut(item);
  }
});

////VID SRCSET

//get all vids
var video = document.getElementById('topperVideo');

//add source to video tag
function addSourceToVideo(element, src) {
  var source = document.createElement('source');
  source.src = src;
  source.type = 'video/mp4';
  element.appendChild(source);
}

//init only if page has videos
function videoSize() {
  if (isMobile) {
    addSourceToVideo(video, video.dataset.mobile);
  } else {
    addSourceToVideo(video, video.dataset.desktop);
  }
}
videoSize();

// var scenes = document.querySelector('.card');

// const scroller = new Scroller({
//   container: document.querySelector('.scroller-container-topper'),
//   scenes: scenes,
// });

// scroller.on('container:enter', function (d) {
//   console.log('enter:', d);
//   // topperBackground.classList.remove('opacity-active');
//   // topperBackground.classList.add('opacity-active');
// });

// scroller.on('container:exit', function (d) {
//   console.log('exit:', d);
//   // topperBackground.classList.remove('opacity-active');
//   // topperBackground.classList.add('opacity-inactive');
// });

// scroller.init();
